import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { BaseModel } from '../../../models/base.model';
import { AuthService } from '../../../auth/auth.service';
import { Society } from '../../../models/society.model';
import { Department } from '../../../models/department.model';
import { Client } from '../../../models/client.model';
import { Contact } from '../../../models/contact.model';
import { Profile } from '../../../models/profile.model';
import { Subsystem } from '../../../models/subsystem.model';
import { System } from '../../../models/system.model';
import { Technology } from '../../../models/technology.model';
import { Type } from '../../../models/type.model';
import { User } from '../../../models/user.model';
import { Tenant } from '../../../models/tenant.model'; // NUEVO

@Component({
  selector: 'app-master-menu',
  templateUrl: './master-menu.component.html',
  styleUrls: ['./master-menu.component.scss']
})
export class MasterMenuComponent implements OnInit {
  @Output() entitySelected = new EventEmitter<BaseModel>();

  activeMenu: string = ''; 

  private allEntities = [
    { name: 'Tenants', instance: new Tenant(), requiredPermission: 'SUPERADMIN_ONLY' }, // NUEVO
    { name: 'Clientes', instance: new Client(), requiredPermission: 'menu:master:manage' },
    { name: 'Sociedades', instance: new Society(), requiredPermission: 'menu:master:manage' },
    { name: 'Departamentos', instance: new Department(), requiredPermission: 'menu:master:manage' },
    { name: 'Contactos', instance: new Contact(), requiredPermission: 'menu:master:manage' },
    { name: 'Perfiles', instance: new Profile(), requiredPermission: 'menu:master:manage' },
    { name: 'Sistemas', instance: new System(), requiredPermission: 'menu:master:manage' },
    { name: 'Subsistemas', instance: new Subsystem(), requiredPermission: 'menu:master:manage' },
    { name: 'Tecnologías', instance: new Technology(), requiredPermission: 'menu:master:manage' },
    { name: 'Tipos', instance: new Type(), requiredPermission: 'menu:master:manage' }
    // { name: 'Usuarios', instance: new User(), requiredPermission: 'menu:master:manage' }
  ];

  entities: any[] = [];

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.permissions$.subscribe(permisos => {
      this.filterMenu();
    });
  }

  filterMenu() {
    const isSuperAdmin = this.authService.isSuperAdmin();

    this.entities = this.allEntities.filter(entity => {
      // Regla especial: Solo SuperAdmin ve los Tenants
      if (entity.requiredPermission === 'SUPERADMIN_ONLY') {
        return isSuperAdmin;
      }

      // Regla normal
      const tieneAcceso = this.authService.hasPermission(entity.requiredPermission);
      return tieneAcceso || isSuperAdmin;
    });
  }

  selectEntity(entityInstance: BaseModel) {
    this.entitySelected.emit(entityInstance);
  }
}